import ddt from '@wix/da-ddt';
import { toJsonString, isSSR } from '../utils';
import { BiContextProvidedValue, BiData } from '@wix/da-bi/pkg/events';
import biLogger from '@wix/da-bi/pkg/BiLogger.logger';
import { mergeEventDataWithContext } from '@wix/da-bi/pkg/hooks/useBiLogger';
export const DEV_SCRIPT_URL = 'https://s.nitropay.com/ads-1240.js';
export const PROD_SCRIPT_URL = 'https://s.nitropay.com/ads-1239.js';
class NitroAds {
    logBi(eventData) {
        // Limit units to 2 logs max
        const loggedId = `${eventData.adUnitId}${eventData.evid}`;
        if (this.biLogged[loggedId] >= 2) {
            ddt.log('ads', 'Skip BI at limit', loggedId);
            return;
        }
        var _loggedId;
        this.biLogged[loggedId] = ((_loggedId = this.biLogged[loggedId]) !== null && _loggedId !== void 0 ? _loggedId : 0) + 1;
        if (!this.biContext) {
            this.logQueue.push(eventData);
            return;
        }
        biLogger.log(this.publicSession, mergeEventDataWithContext(eventData, this.biContext), false);
        this.flushBiQueue();
    }
    flushBiQueue() {
        if (this.logQueue.length > 0) {
            for (const item of this.logQueue){
                biLogger.log(this.publicSession, mergeEventDataWithContext(item, this.biContext), false);
            }
            this.logQueue = [];
        }
    }
    init() {
        if (!isSSR()) {
            try {
                // Replay events that happen before react lives
                if (window.__DAADS__ && Array.isArray(window.__DAADS__.ev)) {
                    for (const storedEvt of window.__DAADS__.ev){
                        ddt.log('ads', `nitro boot evt ${storedEvt.ev}`, storedEvt === null || storedEvt === void 0 ? void 0 : storedEvt.e);
                        if (storedEvt.ev === 'prepare') {
                            var ref, ref1;
                            this.logBi(BiData({
                                evid: 8883,
                                adUnitId: storedEvt === null || storedEvt === void 0 ? void 0 : (ref = storedEvt.e) === null || ref === void 0 ? void 0 : (ref1 = ref.holder) === null || ref1 === void 0 ? void 0 : ref1.id,
                                unsafe: BiContextProvidedValue,
                                itemid: BiContextProvidedValue,
                                typeid: BiContextProvidedValue
                            }));
                        }
                        if (storedEvt.ev === 'rendered') {
                            var ref2, ref3, ref4, ref5, ref6;
                            this.logBi(BiData({
                                evid: 8885,
                                adUnitId: storedEvt === null || storedEvt === void 0 ? void 0 : (ref2 = storedEvt.e) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.adInfo) === null || ref3 === void 0 ? void 0 : ref3.adUnitCode,
                                unsafe: BiContextProvidedValue,
                                itemid: BiContextProvidedValue,
                                typeid: BiContextProvidedValue,
                                type: storedEvt === null || storedEvt === void 0 ? void 0 : (ref4 = storedEvt.e) === null || ref4 === void 0 ? void 0 : ref4.type,
                                adInfo: castAdInfoCpm(storedEvt === null || storedEvt === void 0 ? void 0 : (ref5 = storedEvt.e) === null || ref5 === void 0 ? void 0 : ref5.adInfo),
                                cpm: storedEvt === null || storedEvt === void 0 ? void 0 : (ref6 = storedEvt.e) === null || ref6 === void 0 ? void 0 : ref6.adInfo.cpm
                            }));
                        }
                    }
                    window.__DAADS__.ev = false;
                }
                // Events for BI/Debug
                document.addEventListener('nitroAds.loaded', (event)=>{
                    ddt.log('ads', 'nitro evt loaded', event === null || event === void 0 ? void 0 : event.detail);
                });
                document.addEventListener('nitroAds.createAd', (event)=>{
                    ddt.log('ads', 'nitro evt createAd', event === null || event === void 0 ? void 0 : event.detail);
                });
                document.addEventListener('nitroAds.prepare', (event)=>{
                    ddt.log('ads', 'nitro evt prepare', event === null || event === void 0 ? void 0 : event.detail);
                    this.logBi(BiData({
                        evid: 8883,
                        adUnitId: event.detail.holder.id,
                        unsafe: BiContextProvidedValue,
                        itemid: BiContextProvidedValue,
                        typeid: BiContextProvidedValue
                    }));
                });
                document.addEventListener('nitroAds.bidReceived', (event)=>{
                    ddt.log('ads', 'nitro evt bid', event === null || event === void 0 ? void 0 : event.detail);
                });
                document.addEventListener('nitroAds.rendered', (event)=>{
                    ddt.log('ads', 'nitro evt rendered', event === null || event === void 0 ? void 0 : event.detail);
                    this.logBi(BiData({
                        evid: 8885,
                        adUnitId: event.detail.adInfo.adUnitCode,
                        unsafe: BiContextProvidedValue,
                        itemid: BiContextProvidedValue,
                        typeid: BiContextProvidedValue,
                        type: event.detail.type,
                        adInfo: castAdInfoCpm(event.detail.adInfo),
                        cpm: event.detail.adInfo.cpm
                    }));
                });
                document.addEventListener('nitroAds.anchorVisibility', (event)=>{
                    ddt.log('ads', 'nitro evt anchorVis', event === null || event === void 0 ? void 0 : event.detail);
                });
                document.addEventListener('nitroAds.complete', (event)=>{
                    ddt.log('ads', 'nitro evt complete', event === null || event === void 0 ? void 0 : event.detail);
                    this.logBi(BiData({
                        evid: 8888,
                        adUnitId: event.detail.adUnitCode,
                        unsafe: BiContextProvidedValue,
                        itemid: BiContextProvidedValue,
                        typeid: BiContextProvidedValue,
                        type: event.detail.type
                    }));
                });
                window.addEventListener('pagehide', ()=>{
                    this.flushBiQueue();
                });
            } catch (e) {
                ddt.alertOnError(e, 'ads', 'Fatal in ads BI', [
                    'ads'
                ], e.message);
            }
        }
    }
    registerUnit(unitId, options) {
        if (!isSSR()) {
            ddt.log('ads', 'register nitro client ad', unitId);
            window['nitroAds'].createAd(unitId, options);
        } else {
            ddt.log('ads', 'register nitro ssr ad', unitId);
            this.ssrUnits[unitId] = options;
        }
    }
    killUnit(unitId) {
    // noop as nitro auto cleanup once the ad is removed from DOM
    }
    toSSR() {
        let output = '';
        for (const key of Object.keys(this.ssrUnits)){
            output = `${output}\nwindow["nitroAds"].createAd("${key}", JSON.parse(${toJsonString(this.ssrUnits[key])}));`;
        }
        return output;
    }
    setBiContext(context, session) {
        this.biContext = context;
        this.publicSession = session;
    }
    constructor(){
        this.ssrUnits = {};
        this.logQueue = [];
        this.biLogged = {};
    }
}
function castAdInfoCpm(adInfo) {
    return JSON.stringify({
        cpm: `${adInfo.cpm}`,
        bidder: adInfo.bidder
    });
}
export default NitroAds;
